export enum PrimaryVehicleIdentifier {
  LicensePlate = 0,
  ChassisNumber = 1,
}

export enum ChassisNumberDisplayMode {
  LastSixCharacters = 0,
  Full = 1,
}

export const PrimaryVehicleIdentifierOptions = [
  { value: PrimaryVehicleIdentifier.LicensePlate, label: 'core.vehicle_identifier.primary.license_plate' },
  { value: PrimaryVehicleIdentifier.ChassisNumber, label: 'core.vehicle_identifier.primary.chassis_number' },
];

export const ChassisNumberDisplayModeOptions = [
  { value: ChassisNumberDisplayMode.LastSixCharacters, label: 'core.vehicle_identifier.chassis_display.last_six' },
  { value: ChassisNumberDisplayMode.Full, label: 'core.vehicle_identifier.chassis_display.full' },
];

export interface VehicleIdentifierSettings {
  primaryVehicleIdentifier: PrimaryVehicleIdentifier;
  chassisNumberDisplayMode: ChassisNumberDisplayMode;
}

export const DEFAULT_VEHICLE_IDENTIFIER_SETTINGS: VehicleIdentifierSettings = {
  primaryVehicleIdentifier: PrimaryVehicleIdentifier.LicensePlate,
  chassisNumberDisplayMode: ChassisNumberDisplayMode.LastSixCharacters,
};
